import React, { useEffect, useState } from "react";
import {
  Box, Button, Flex, Table, Tbody, Td, Th, Thead, Tr, Text, useToast, Spinner,
  Badge, Heading,
} from "@chakra-ui/react";
import { getWaitlistDemand } from "../../utils/apis/agentApi";

/** Unmet demand: customers who asked for a trade we could not fill in their
 *  area and agreed to be told when someone joins. This is the recruiter's
 *  targeting map, the rows at the top are where a new provider earns work on
 *  day one. "Won back" counts the people already notified once supply arrived. */
const Waitlist = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const load = async () => {
    setLoading(true);
    const res = await getWaitlistDemand();
    if (res.ok && Array.isArray(res.data)) setRows(res.data);
    else
      toast({
        title: res.status === 502 ? "Agent unreachable" : "Failed to load",
        status: "error", duration: 3000, isClosable: true,
      });
    setLoading(false);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const totalWaiting = rows.reduce((n, r) => n + Number(r.waiting || 0), 0);

  return (
    <Box p={5}>
      <Flex justifyContent="space-between" alignItems="center" mb={1}>
        <Heading size="md">Unmet demand</Heading>
        <Button size="sm" onClick={load} isDisabled={loading}>Refresh</Button>
      </Flex>
      <Text fontSize="sm" color="admin.muted" mb={4}>
        Customers who asked for a trade we could not fill nearby, and agreed to
        be told when someone joins. Recruit the top rows first.
      </Text>

      {loading ? (
        <Flex justifyContent="center" py={10}><Spinner /></Flex>
      ) : rows.length === 0 ? (
        <Text color="admin.muted">
          No one is waiting. Either every request found a provider, or nobody has
          opted in yet.
        </Text>
      ) : (
        <>
          <Text fontSize="sm" mb={2}>
            <b>{totalWaiting}</b> waiting across <b>{rows.length}</b> trade and
            area combinations
          </Text>
          <Table size="sm" variant="simple">
            <Thead>
              <Tr>
                <Th>Trade</Th>
                <Th>Area</Th>
                <Th isNumeric>Waiting</Th>
                <Th isNumeric>Won back</Th>
                <Th>Latest request</Th>
              </Tr>
            </Thead>
            <Tbody>
              {rows.map((r, i) => (
                <Tr key={`${r.category}-${r.area}-${i}`}>
                  <Td>{r.category || "unknown"}</Td>
                  <Td>{r.area || "unknown"}</Td>
                  <Td isNumeric>
                    <Badge colorScheme={Number(r.waiting) > 0 ? "red" : "gray"}>
                      {r.waiting ?? 0}
                    </Badge>
                  </Td>
                  <Td isNumeric>
                    <Badge colorScheme={Number(r.won_back) > 0 ? "green" : "gray"}>
                      {r.won_back ?? 0}
                    </Badge>
                  </Td>
                  <Td>{r.latest ? new Date(r.latest).toLocaleDateString() : "-"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </>
      )}
    </Box>
  );
};

export default Waitlist;
